import React from 'react'

const AboutUsSection = () => {
    return (
        <div className="about-us-section">
            <ul>
                <li>
                    <a href={`/${document.body.dataset.site}/sobre-nosotros`}>Sobre Nosotros</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/faq`}>Preguntas Frecuentes</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/terminos`}>Términos y Condiciones</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/terminos`}>Politicas de Privacidad</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/precios`}>Planes y Precios</a>
                </li>
            </ul>
        </div>
    )
}

export default AboutUsSection
